let onDateChange:
  | ((data: {
      filterType: string;
      startDate?: Date | null;
      endDate?: Date | null;
    }) => void)
  | null = null;

export function registerDateChangeCallback(cb: typeof onDateChange) {
  onDateChange = cb;
}

export function emitDateChange(data: {
  filterType: string;
  startDate?: Date | null;
  endDate?: Date | null;
}) {
  if (onDateChange) {
    onDateChange(data);
  }
}
